import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import "./PrivacyPolicy.css";

function PrivacyComponent() {
  return (
    <div>
      <Container fluid id="hero" className="herosection">
        <Container fluid className="containersectionabt">
          <Row>
            <Col xs={12} md={8} lg={6}>
              <h2
                style={{
                  color: "#FFFFFF",
                  fontFamily: "jost",
                  fontSize: 2.5 + "rem",
                }}
              >
                <strong>Lodapoint Privacy Policy</strong>
              </h2>
              <p
                style={{
                  color: "#FFFFFF",
                  fontSize: 0.75 + "rem",
                  lineHeight: 224 + "%",
                  fontFamily: "jost",
                }}
              >
                Last Updated: 31 March 2026
              </p>
            </Col>
            <Col xs={12} md={4} lg={6}></Col>
          </Row>
        </Container>
      </Container>

      <Container
        fluid
        id="hero"
        className="headings"
        style={{ marginTop: -4 + "rem", fontFamily: "jost" }}
      >
        <Container>
          <h3>
            <strong>1. INTRODUCTION</strong>
          </h3>
          <p className="privacy-content">
            At Lodapoint, we take your privacy seriously.
          </p>
          <p className="privacy-content">
            Lodapoint Technologies Ltd. ("Lodapoint", "we", "our", or "us") operates a platform that connects people and businesses for mobility and logistics services. This includes ride-hailing (cars and tricycles), truck and freight services, and delivery solutions.
          </p>
          <p className="privacy-content">
            To make these services work smoothly, we need to collect and use certain information about you. This Privacy Policy explains:
          </p>
          <ul className="privacy-content">
            <li>What information we collect</li>
            <li>Why we collect it</li>
            <li>How we use it</li>
            <li>Who we share it with</li>
            <li>The choices and rights you have</li>
          </ul>
          <p className="privacy-content">
            We've tried to keep this as clear and straightforward as possible so you can easily understand how your data is handled.
          </p>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>2. WHO THIS POLICY APPLIES TO</strong>
          </h3>
          <p className="privacy-content">
            This policy applies to anyone who uses Lodapoint, including:
          </p>
          <ul className="privacy-content">
            <li>Riders requesting trips</li>
            <li>Drivers and transporters providing services</li>
            <li>Individuals and businesses shipping goods</li>
            <li>Visitors to our website or apps</li>
          </ul>
          <p className="privacy-content">
            Even if you only browse our platform without creating an account, some limited data may still be collected (like device or usage data).
          </p>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>3. THE INFORMATION WE COLLECT</strong>
          </h3>
          <p className="privacy-content">
            We only collect information that helps us operate our services effectively, safely, and reliably.
          </p>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>3.1 Information You Provide to Us</strong>
          </h4>
          <p className="privacy-content">
            When you sign up or use Lodapoint, you may provide:
          </p>
          <ul className="privacy-content">
            <li>Your name</li>
            <li>Phone number</li>
            <li>Email address</li>
            <li>Profile photo</li>
            <li>Identification documents (for verification, especially for drivers/transporters)</li>
            <li>Vehicle or fleet details (for transporters)</li>
            <li>Business information (for companies using logistics services)</li>
            <li>Payment or bank details</li>
          </ul>
          <p className="privacy-content">
            We keep this information secure and only use it for legitimate purposes explained below.
          </p>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>3.2 Your Phone Number and Email (Important)</strong>
          </h4>
          <p className="privacy-content">
            Your phone number and email are essential to how Lodapoint works.
          </p>
          <p className="privacy-content">
            We use them to:
          </p>
          <ul className="privacy-content">
            <li>Create and manage your account</li>
            <li>Send you One-Time Passwords (OTP) during signup and login</li>
            <li>Confirm your identity and prevent unauthorized access</li>
            <li>Send important updates like trip confirmations and receipts</li>
            <li>Contact you for support when needed</li>
          </ul>
          <p className="privacy-content">
            These messages are service-related, not marketing. Without them, key parts of the app would not function properly.
          </p>
          <p className="privacy-content">
            <strong>To protect your privacy:</strong>
          </p>
          <ul className="privacy-content">
            <li>Your phone number is not shared openly with other users</li>
            <li>Calls and messages may be routed through secure masking systems</li>
          </ul>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>3.3 Location Information</strong>
          </h4>
          <p className="privacy-content">
            Location data is one of the most important parts of our service.
          </p>
          <p className="privacy-content">
            When you use Lodapoint, we may collect:
          </p>
          <ul className="privacy-content">
            <li>Your real-time location</li>
            <li>Pickup and drop-off points</li>
            <li>Routes taken during trips</li>
          </ul>
          <p className="privacy-content">
            We use this information to:
          </p>
          <ul className="privacy-content">
            <li>Match you with nearby drivers or transporters</li>
            <li>Help drivers find you easily</li>
            <li>Track trips in real time for safety</li>
            <li>Ensure accurate pricing</li>
          </ul>
          <p className="privacy-content">
            In some cases, location data may be collected in the background while a trip is ongoing, so the service continues to work even if the app is not actively open.
          </p>
          <p className="privacy-content">
            You can control location permissions from your device settings, but disabling them may affect how the app works.
          </p>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>3.4 Information We Collect Automatically</strong>
          </h4>
          <p className="privacy-content">
            When you use our app or website, we automatically collect certain technical information, such as:
          </p>
          <ul className="privacy-content">
            <li>Device type and model</li>
            <li>Operating system</li>
            <li>IP address</li>
            <li>App usage activity (e.g., features used, time spent)</li>
            <li>Crash logs and diagnostics</li>
          </ul>
          <p className="privacy-content">
            This helps us understand how people use Lodapoint and improve performance.
          </p>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>3.5 Payments and Transactions</strong>
          </h4>
          <p className="privacy-content">
            When you make payments through Lodapoint, we collect information about:
          </p>
          <ul className="privacy-content">
            <li>Trip fares and charges</li>
            <li>Payment methods used</li>
            <li>Wallet transactions (if applicable)</li>
          </ul>
          <p className="privacy-content">
            We do not store sensitive payment details directly—these are handled securely by trusted payment providers.
          </p>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>3.6 Communication and Support</strong>
          </h4>
          <p className="privacy-content">
            If you contact support or communicate through the app, we may collect:
          </p>
          <ul className="privacy-content">
            <li>Messages sent through in-app chat</li>
            <li>Support emails or complaints</li>
            <li>Feedback and ratings</li>
          </ul>
          <p className="privacy-content">
            This helps us resolve issues and improve service quality.
          </p>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>3.7 Information from Third Parties</strong>
          </h4>
          <p className="privacy-content">
            Sometimes, we may receive information from trusted third parties, such as:
          </p>
          <ul className="privacy-content">
            <li>Identity verification providers</li>
            <li>Payment processors</li>
            <li>Analytics services</li>
          </ul>
          <p className="privacy-content">
            This is typically used to confirm identities, prevent fraud, or improve the platform.
          </p>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>4. HOW WE USE YOUR INFORMATION</strong>
          </h3>
          <p className="privacy-content">
            We use your information to run Lodapoint effectively and safely.
          </p>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>4.1 To Provide Our Services</strong>
          </h4>
          <p className="privacy-content">
            This includes:
          </p>
          <ul className="privacy-content">
            <li>Connecting riders with drivers</li>
            <li>Assigning transporters for deliveries</li>
            <li>Managing bookings and dispatch</li>
            <li>Processing payments</li>
          </ul>
          <p className="privacy-content">
            Without this data, the platform simply wouldn't function.
          </p>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>4.2 To Keep the Platform Safe</strong>
          </h4>
          <p className="privacy-content">
            Safety is a major priority for us.
          </p>
          <p className="privacy-content">
            We use data to:
          </p>
          <ul className="privacy-content">
            <li>Verify users (KYC checks)</li>
            <li>Monitor trips in real time</li>
            <li>Detect suspicious or fraudulent activity</li>
            <li>Respond to emergencies</li>
          </ul>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>4.3 To Communicate With You</strong>
          </h4>
          <p className="privacy-content">
            We use your phone number and email to:
          </p>
          <ul className="privacy-content">
            <li>Send OTPs and login verification codes</li>
            <li>Provide trip updates and receipts</li>
            <li>Notify you of important changes</li>
            <li>Respond to your support requests</li>
          </ul>
          <p className="privacy-content">
            You may also receive promotional messages, but you can opt out anytime.
          </p>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>4.4 To Improve Lodapoint</strong>
          </h4>
          <p className="privacy-content">
            We analyze usage patterns to:
          </p>
          <ul className="privacy-content">
            <li>Improve matching between users and drivers</li>
            <li>Optimize pricing and routes</li>
            <li>Fix bugs and improve app performance</li>
          </ul>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>4.5 For Legal and Compliance Reasons</strong>
          </h4>
          <p className="privacy-content">
            We may use your data to:
          </p>
          <ul className="privacy-content">
            <li>Comply with applicable laws and regulations</li>
            <li>Respond to lawful requests from authorities</li>
            <li>Enforce our terms and policies</li>
          </ul>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>5. HOW WE SHARE YOUR INFORMATION</strong>
          </h3>
          <p className="privacy-content">
            We do not sell your personal data.
          </p>
          <p className="privacy-content">
            However, we may share it in limited and necessary situations:
          </p>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>5.1 Between Users</strong>
          </h4>
          <p className="privacy-content">
            To make the service work:
          </p>
          <ul className="privacy-content">
            <li>Riders see driver details (name, vehicle, rating)</li>
            <li>Drivers see rider details (name and pickup location)</li>
          </ul>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>5.2 With Service Providers</strong>
          </h4>
          <p className="privacy-content">
            We work with trusted partners such as:
          </p>
          <ul className="privacy-content">
            <li>Payment processors</li>
            <li>Cloud hosting providers</li>
            <li>Analytics services</li>
          </ul>
          <p className="privacy-content">
            They only access what is necessary to perform their role.
          </p>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>5.3 With Business Partners</strong>
          </h4>
          <p className="privacy-content">
            For logistics services, data may be shared with:
          </p>
          <ul className="privacy-content">
            <li>Fleet owners</li>
            <li>Logistics partners</li>
            <li>Enterprise clients</li>
          </ul>

          <h4 style={{ marginTop: 1.5 + "rem" }}>
            <strong>5.4 With Authorities</strong>
          </h4>
          <p className="privacy-content">
            We may share data if required to:
          </p>
          <ul className="privacy-content">
            <li>Comply with the law</li>
            <li>Protect users or the public</li>
            <li>Respond to legal requests</li>
          </ul>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>6. HOW LONG WE KEEP YOUR DATA</strong>
          </h3>
          <p className="privacy-content">
            We keep your data only as long as necessary.
          </p>
          <p className="privacy-content">
            This depends on:
          </p>
          <ul className="privacy-content">
            <li>Whether your account is active</li>
            <li>Legal and regulatory requirements</li>
            <li>Fraud prevention needs</li>
          </ul>
          <p className="privacy-content">
            When data is no longer needed, we delete or anonymize it securely.
          </p>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>7. YOUR RIGHTS</strong>
          </h3>
          <p className="privacy-content">
            You have control over your personal data.
          </p>
          <p className="privacy-content">
            You may:
          </p>
          <ul className="privacy-content">
            <li>Request access to your data</li>
            <li>Correct inaccurate information</li>
            <li>Request deletion of your account</li>
            <li>Object to certain types of processing</li>
          </ul>
          <p className="privacy-content">
            To make a request, contact: <strong>privacy@lodapoint.com</strong>
          </p>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>8. CHILDREN AND MINORS</strong>
          </h3>
          <p className="privacy-content">
            Lodapoint may be used by individuals under 18.
          </p>
          <p className="privacy-content">
            However:
          </p>
          <ul className="privacy-content">
            <li>Minors should use the platform with parent or guardian permission</li>
            <li>Parents/guardians are responsible for supervising usage</li>
          </ul>
          <p className="privacy-content">
            If you believe a minor has provided information improperly, please contact us and we will take appropriate action.
          </p>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>9. HOW WE PROTECT YOUR DATA</strong>
          </h3>
          <p className="privacy-content">
            We take security seriously and use measures such as:
          </p>
          <ul className="privacy-content">
            <li>Data encryption</li>
            <li>Secure servers</li>
            <li>Access controls</li>
            <li>Monitoring for suspicious activity</li>
          </ul>
          <p className="privacy-content">
            We also protect account access using OTP verification systems.
          </p>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>10. INTERNATIONAL DATA TRANSFERS</strong>
          </h3>
          <p className="privacy-content">
            Your data may be processed outside your country where necessary.
          </p>
          <p className="privacy-content">
            We ensure appropriate safeguards are in place to protect your information.
          </p>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>11. COOKIES AND TRACKING</strong>
          </h3>
          <p className="privacy-content">
            We use cookies and similar tools to:
          </p>
          <ul className="privacy-content">
            <li>Improve performance</li>
            <li>Understand usage</li>
            <li>Enhance your experience</li>
          </ul>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>12. CHANGES TO THIS POLICY</strong>
          </h3>
          <p className="privacy-content">
            We may update this Privacy Policy from time to time.
          </p>
          <p className="privacy-content">
            If changes are significant, we will notify you.
          </p>

          <h3 style={{ marginTop: 2.5 + "rem" }}>
            <strong>13. CONTACT US</strong>
          </h3>
          <p className="privacy-content">
            If you have any questions:
          </p>
          <p className="privacy-content">
            <strong>Lodapoint Technologies Ltd.</strong>
          </p>
          <p className="privacy-content">
            Email: <strong>info@lodapoint.com</strong>
          </p>
          <p className="privacy-content">
            Website: <strong>www.lodapoint.com</strong>
          </p>
        </Container>
      </Container>
    </div>
  );
}

export default PrivacyComponent;
